import { render } from "./ProfileHeader.vue?vue&type=template&id=6df168a0&ts=true"
import script from "./ProfileHeader.vue?vue&type=script&lang=ts"
export * from "./ProfileHeader.vue?vue&type=script&lang=ts"

import "./ProfileHeader.vue?vue&type=style&index=0&id=6df168a0&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/profile/ProfileHeader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6df168a0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6df168a0', __exports__)) {
    api.reload('6df168a0', __exports__)
  }
  
  module.hot.accept("./ProfileHeader.vue?vue&type=template&id=6df168a0&ts=true", () => {
    api.rerender('6df168a0', render)
  })

}


export default __exports__